import React, { useEffect, useState } from "react";
import * as style from "./styles.mod.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import getImagePath from "helpers/get-image-path";

const BREAKPOINTS = {
  MOBILE: 560,
  TABLET: 1024,
};

const SPACE_BETWEEN = {
  MOBILE: 5,
  TABLET: 10,
  DESKTOP: 20,
};

const getDeviceType = (width) => {
  if (width <= BREAKPOINTS.MOBILE) {
    return "mobile";
  }
  if (width <= BREAKPOINTS.TABLET) {
    return "tablet";
  }
  return "desktop";
};

const LogoList = ({ data: { icons } }) => {
  const [deviceType, setDeviceType] = useState("desktop");

  useEffect(() => {
    const handleResize = () => {
      if (typeof window !== "undefined") {
        setDeviceType(getDeviceType(window.innerWidth));
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const spaceBetween = SPACE_BETWEEN[deviceType.toUpperCase()] || SPACE_BETWEEN.DESKTOP;
  const slidesPerView = deviceType === "mobile" ? 3.2 : deviceType === "tablet" ? 4.2 : 6;

  return (
    <div className={style.logoListContainer}>
      <Swiper
        spaceBetween={spaceBetween}
        slidesPerView={slidesPerView}
        loop={false}
        freeMode={true}
        grabCursor={true}
      >
        {icons.map((item, index) => (
          <SwiperSlide key={index} className={style.imageContainer}>
            <img src={getImagePath(item)} alt={item.alt} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default LogoList;
